module.exports = __webpack_public_path__ + "static/media/profile-icon.06954195.png";